import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/600.css';
import '@fontsource/roboto/700.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/playfair-display/400.css';
import '@fontsource/playfair-display/600.css';
import '@fontsource/playfair-display/700.css';
import '@fontsource/merriweather/400.css';
import '@fontsource/merriweather/700.css';
import './siteFonts.css';

import type { SiteFontKey, SiteTypography } from '@store/slices/settingsSlice.tsx';

export const DEFAULT_SITE_TYPOGRAPHY: SiteTypography = {
  heading_font: 'inherit',
  subheading_font: 'inherit',
  body_font: 'inherit',
};

export const SITE_FONT_OPTIONS: Array<{
  value: SiteFontKey;
  label: string;
  family: string;
}> = [
  { value: 'inherit', label: 'Predeterminada del diseño', family: 'inherit' },
  { value: 'inter', label: 'Inter', family: '"Inter", sans-serif' },
  { value: 'roboto', label: 'Roboto', family: '"Roboto", sans-serif' },
  { value: 'open_sans', label: 'Open Sans', family: '"Open Sans", sans-serif' },
  { value: 'lato', label: 'Lato', family: '"Lato", sans-serif' },
  { value: 'montserrat', label: 'Montserrat', family: '"Montserrat", sans-serif' },
  { value: 'poppins', label: 'Poppins', family: '"Poppins", sans-serif' },
  { value: 'playfair_display', label: 'Playfair Display', family: '"Playfair Display", serif' },
  { value: 'merriweather', label: 'Merriweather', family: '"Merriweather", serif' },
  { value: 'anton', label: 'Anton Regular', family: '"Anton Regular", sans-serif' },
  { value: 'audiowide', label: 'Audiowide Regular', family: '"Audiowide Regular", sans-serif' },
  { value: 'didot', label: 'Didot LT Std Headline', family: '"Didot LT Std Headline", serif' },
  { value: 'fang_song', label: 'Fang Song', family: '"Fang Song", serif' },
  { value: 'inria_sans', label: 'Inria Sans', family: '"Inria Sans", sans-serif' },
  { value: 'bookman_old_style', label: 'Bookman Old Style', family: '"Bookman Old Style", serif' },
  { value: 'optima_italic', label: 'Optima Italic', family: '"Optima Italic", serif' },
];

const familyByKey = Object.fromEntries(
  SITE_FONT_OPTIONS.map((option) => [option.value, option.family]),
) as Record<SiteFontKey, string>;

const STYLE_ID = 'site-public-typography';

export function normalizeSiteTypography(value?: SiteTypography | null): SiteTypography {
  return { ...DEFAULT_SITE_TYPOGRAPHY, ...(value ?? {}) };
}

export function applySiteTypographyToDom(value?: SiteTypography | null) {
  if (typeof document === 'undefined') return;
  const typography = normalizeSiteTypography(value);
  let style = document.getElementById(STYLE_ID) as HTMLStyleElement | null;
  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    document.head.appendChild(style);
  }
  style.textContent = `
    .legacy-web-page,
    .eshop-layout {
      --site-font-heading: ${familyByKey[typography.heading_font]};
      --site-font-subheading: ${familyByKey[typography.subheading_font]};
      --site-font-body: ${familyByKey[typography.body_font]};
    }
  `;
}
